import {
  DEFAULT_OG_IMAGE_HEIGHT,
  DEFAULT_OG_IMAGE_WIDTH,
  getSectionOgImageUrl,
} from "@config/ogImageConstants";
import { capitalize } from "@src/app/helper/stringTransform";
import type { GADataProps } from "@typings/GA";
import type { MetaTagsProps } from "@typings/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function AuthorMetaData(
  authorAlias: string,
  authorName?: string,
): PageMetaDataValues {
  const authorDisplayName =
    authorName || authorAlias.split("/").pop()?.replace(/-/g, " ") || "";
  const TitleCaseAuthor: string = capitalize(authorDisplayName);
  const metaTags: MetaTagsProps = {
    title: `${TitleCaseAuthor} - Beritaharian`,
    description: `Read articles by ${TitleCaseAuthor} on Berita Harian, covering Singapura, Malaysia and berita terkini`,
    slug: authorAlias,
    ogImage: {
      url: getSectionOgImageUrl("default"),
      width: DEFAULT_OG_IMAGE_WIDTH,
      height: DEFAULT_OG_IMAGE_HEIGHT,
    },
  };

  const gaData: GADataProps = {
    level2: "miscellaneous",
    section: "miscellaneous",
    contentcat: "1",
    contenttype: "listing",
  };

  return {
    gaData,
    metaTags,
  };
}
